// extracted by mini-css-extract-plugin
export var container = "_uz-0";
export var table = "_uz-2";
export var tableWrapper = "_uz-1";